import './Coins.css';
import coin from '../../assets/coin.png';

export default function Coins({coinsAmount}){
    return (
        <div className="coins-container">
            {coinsAmount}
            <img src={coin} alt="coin" />
        </div>
    )
}